<template>
  <div class="global-content-box global-content-flex">
    <y-menu-title />
    <el-tabs v-model="activeName" @tab-click="tabChange">
      <el-tab-pane label="基准积分标准" name="first"> </el-tab-pane>
      <el-tab-pane label="积分奖励规则" name="second"> </el-tab-pane>
      <el-tab-pane label="积分屏蔽规则" name="third"> </el-tab-pane>
      <el-tab-pane label="积分扣减规则" name="fourth"> </el-tab-pane>
    </el-tabs>
    <div class="global-felx-1">
      <benchmarkPointsStandard v-if="activeName == 'first'" />
      <reward_rules v-if="activeName == 'second'" />
      <shield_rules v-if="activeName == 'third'" />
      <deduction_rules v-if="activeName == 'fourth'" />
    </div>
  </div>
</template>

<script>
import benchmarkPointsStandard from "./prop/benchmark_points_standard.vue";
import deduction_rules from "./prop/deduction_rules.vue";
import reward_rules from "./prop/reward_rules.vue";
import shield_rules from "./prop/shield_rules.vue";
export default {
  components: {
    benchmarkPointsStandard,
    deduction_rules,
    reward_rules,
    shield_rules,
  },
  data() {
    return {
      activeName: "first",
    };
  },
  created() {
    this.buriedPoint(1, "忠诚度管理", "忠诚度管理", "积分发放规则");
  },
  methods: {
    // 切换页面
    tabChange() {},
  },
};
</script>